import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Ent icon
 *
 * @category Medical
 */
const Ent = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M16.318 29.5c-2.01-.03-4.03-.06-6.04-.08-.5 0-1.02-.02-1.46-.25-.91-.48-1.12-1.71-.95-2.72s.6-1.99.58-3.02c-.04-1.29-.79-2.44-1.45-3.55-1.49-2.54-2.6-5.43-2.38-8.37.22-2.92 1.83-5.7 4.24-7.35s5.59-2.14 8.39-1.29 5.16 3.02 6.25 5.74c.59 1.49.83 3.13 1.68 4.49.74 1.19 1.98 2.3 1.78 3.69-.13.84-.76 1.49-1.37 2.08-.46.45-.93.91-1.52 1.18-.67.31-1.44.34-2.18.31-2.77-.13-5.41-1.16-7.91-2.35-.56-.27-1.19-.55-1.79-.37-.76.23-1.1 1.3-.61 1.93s1.42.64 2.16.95c.91.38 1.55 1.27 1.83 2.21s.26 1.96.17 2.95c-.04.41-.64 2.4-1.02 1.12-.44-1.48.45-3.28-.45-4.53-.81-1.13-2.58-1.09-3.52-2.11-.76-.82-.7-2.26.14-2.99.8-.69 2.01-.65 2.99-.29s1.85.99 2.81 1.43c1.75.79 3.72.9 5.64.92.58 0 1.2 0 1.69-.32s.75-.89 1.21-1.26c.21-.17.47-.3.62-.53.24-.38.11-.87-.07-1.28-.5-1.09-1.35-1.99-1.91-3.05-.72-1.37-.92-2.97-1.54-4.39-.96-2.2-2.97-3.9-5.27-4.58s-4.87-.35-6.98.81c-1.56.86-2.88 2.17-3.64 3.77-.87 1.81-.99 3.92-.62 5.89s1.24 3.83 2.26 5.55c.64 1.07 1.37 2.17 1.41 3.42.05 1.3-.66 2.52-.68 3.82 0 .47.12 1 .53 1.23.23.13.5.13.76.14l6.95.09c.37 0 .75 0 1.08-.17.64-.35.76-1.19.76-1.92s-.03-1.54.48-2.06c.98-1.01 2.99.01 3.99-.99.28-.28.55-.74.93-.64.45.13.32.82 0 1.17-.56.62-1.4.98-2.24.96-.63-.02-1.35-.22-1.84.19-.44.37-.42 1.03-.41 1.6 0 .84-.12 1.76-.75 2.31-.62.54-1.52.56-2.34.55h-.42z"
        />
      </svg>
    );
  }
);

Ent.displayName = 'Ent';

export { Ent };
